







































































import { Component } from 'vue-property-decorator';
// import { Action } from 'vuex-class';

import DclAdd from '@/components/DraggableCardList/DclAdd.vue';
import DclCard from '@/components/DraggableCardList/DclCard.vue';
import DclGrid from '@/components/DraggableCardList/DclGrid.vue';
import HoursSection from './HoursSection';

@Component({
	components: {
		DclAdd,
		DclCard,
		DclGrid,
	}
})
export default class HoursAtm extends HoursSection {
	hoursType = 'atmHours';

	get atm24Hours(): boolean {
		return this.location.atm24Hours;
	}

	set atm24Hours(v: boolean) {
		this.location.atm24Hours = v;
		if (this.location.atm24Hours) {
			this.location.atmHours = [];
		}
	}
}

